import { reactive } from 'vue';

import MatchMediaWatcher from '@/utils/helpers/Match-media';

export const DEVICE_TYPES = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

export interface IAdaptive {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export interface IAdaptiveClass {
  data: IAdaptive;
  watcherMobile: any;
  watcherTablet: any;
  watcherDesktop: any;
}

export default class Adaptive implements IAdaptiveClass {
  data: IAdaptive;

  watcherMobile: any;

  watcherTablet: any;

  watcherDesktop: any;

  constructor(defaultDevice = DEVICE_TYPES.mobile) {
    this.data = reactive<IAdaptive>({
      isMobile: defaultDevice === DEVICE_TYPES.mobile,
      isTablet: defaultDevice === DEVICE_TYPES.tablet,
      isDesktop: defaultDevice === DEVICE_TYPES.desktop,
    });

    this.watcherMobile = null;
    this.watcherTablet = null;
    this.watcherDesktop = null;
  }

  get isMobile() {
    return this.data.isMobile;
  }

  get isTablet() {
    return this.data.isTablet;
  }

  get isDesktop() {
    return this.data.isDesktop;
  }

  initMatchMedia() {
    this.watcherMobile = MatchMediaWatcher.getWatcher();
    this.watcherTablet = MatchMediaWatcher.getWatcher();
    this.watcherDesktop = MatchMediaWatcher.getWatcher();

    this.watcherMobile.addHandler('(max-width: 767px)', (isMatched: boolean) => {
      this.data.isMobile = isMatched;
    });
    this.watcherTablet.addHandler('(min-width: 768px) and (max-width: 1079px)', (isMatched: boolean) => {
      this.data.isTablet = isMatched;
    });
    this.watcherDesktop.addHandler('(min-width: 1080px)', (isMatched: boolean) => {
      this.data.isDesktop = isMatched;
    });

    this.watcherMobile.execute();
    this.watcherTablet.execute();
    this.watcherDesktop.execute();
  }
}
